import { User } from '../types';
import { mockAdminUsers } from './adminUsers';

const adminUserEntries: User[] = mockAdminUsers.map(admin => ({
  id: admin.id,
  email: admin.email,
  role: 'admin' as const,
  firstName: admin.firstName,
  lastName: admin.lastName,
  adminId: admin.id,
}));

export const mockUsers: User[] = [
  {
    id: '550e8400-e29b-41d4-a716-446655440001',
    email: 'emma.johnson@school.edu',
    role: 'student',
    firstName: 'Emma',
    lastName: 'Johnson',
    studentId: '550e8400-e29b-41d4-a716-446655440001',
  },
  {
    id: '550e8400-e29b-41d4-a716-446655440002',
    email: 'liam.smith@school.edu',
    role: 'student',
    firstName: 'Liam',
    lastName: 'Smith',
    studentId: '550e8400-e29b-41d4-a716-446655440002',
  },
  {
    id: '550e8400-e29b-41d4-a716-446655440003',
    email: 'olivia.williams@school.edu',
    role: 'student',
    firstName: 'Olivia',
    lastName: 'Williams',
    studentId: '550e8400-e29b-41d4-a716-446655440003',
  },
  {
    id: '550e8400-e29b-41d4-a716-446655440004',
    email: 'noah.brown@school.edu',
    role: 'student',
    firstName: 'Noah',
    lastName: 'Brown',
    studentId: '550e8400-e29b-41d4-a716-446655440004',
  },
  {
    id: '550e8400-e29b-41d4-a716-446655440005',
    email: 'ava.davis@school.edu',
    role: 'student',
    firstName: 'Ava',
    lastName: 'Davis',
    studentId: '550e8400-e29b-41d4-a716-446655440005',
  },
  {
    id: '650e8400-e29b-41d4-a716-446655440001',
    email: 'michael.johnson@email.com',
    role: 'parent',
    firstName: 'Michael',
    lastName: 'Johnson',
    parentId: '650e8400-e29b-41d4-a716-446655440001',
  },
  {
    id: '650e8400-e29b-41d4-a716-446655440002',
    email: 'sarah.smith@email.com',
    role: 'parent',
    firstName: 'Sarah',
    lastName: 'Smith',
    parentId: '650e8400-e29b-41d4-a716-446655440002',
  },
  {
    id: '650e8400-e29b-41d4-a716-446655440003',
    email: 'david.williams@email.com',
    role: 'parent',
    firstName: 'David',
    lastName: 'Williams',
    parentId: '650e8400-e29b-41d4-a716-446655440003',
  },
  {
    id: '650e8400-e29b-41d4-a716-446655440004',
    email: 'jennifer.brown@email.com',
    role: 'parent',
    firstName: 'Jennifer',
    lastName: 'Brown',
    parentId: '650e8400-e29b-41d4-a716-446655440004',
  },
  {
    id: '650e8400-e29b-41d4-a716-446655440005',
    email: 'robert.davis@email.com',
    role: 'parent',
    firstName: 'Robert',
    lastName: 'Davis',
    parentId: '650e8400-e29b-41d4-a716-446655440005',
  },
  {
    id: '650e8400-e29b-41d4-a716-446655440006',
    email: 'lisa.johnson@email.com',
    role: 'parent',
    firstName: 'Lisa',
    lastName: 'Johnson',
    parentId: '650e8400-e29b-41d4-a716-446655440006',
  },
  {
    id: '750e8400-e29b-41d4-a716-446655440001',
    email: 'james.anderson@email.com',
    role: 'community',
    firstName: 'James',
    lastName: 'Anderson',
    communityMemberId: '750e8400-e29b-41d4-a716-446655440001',
  },
  {
    id: '750e8400-e29b-41d4-a716-446655440002',
    email: 'patricia.martinez@email.com',
    role: 'community',
    firstName: 'Patricia',
    lastName: 'Martinez',
    communityMemberId: '750e8400-e29b-41d4-a716-446655440002',
  },
  ...adminUserEntries,
];

export const communityUserPassword = 'community123';
export const mockPassword = 'password123';
